/**
 * The Codemax mark. The only mark in this application, and there is no second one.
 *
 * Decided 1 September 2026, and written into `CLAUDE.md` rather than left as a
 * preference: the Codemax mark brands everything anybody outside Codemax receives or
 * signs into. A partner's counterparty is Codemax - the agreement, the commission
 * statement and the bank transfer are all Codemax's - and this application's riskiest
 * page asks a partner to trust it with where their money is sent. A page asking for bank
 * details under a product name they have never heard of is what a phishing site looks
 * like.
 *
 * Its own copy of the file rather than an import from the staff application: the two are
 * built and deployed separately, and neither should be able to change the other's mark.
 */
export function CodemaxBrand({ className = 'h-6' }: { className?: string }) {
  return (
    <picture className="block">
      {/* Two files rather than a filter: the wordmark is a gradient, and inverting it
          in CSS turns teal into something that is not the brand. */}
      <source srcSet="/codemax-light.png" media="(prefers-color-scheme: dark)" />
      <img src="/codemax-dark.png" alt="Codemax" className={`block ${className}`} />
    </picture>
  )
}
